import { render, staticRenderFns } from "./WorkSituationalAwareness.vue?vue&type=template&id=ad3d7fb0&scoped=true"
import script from "./WorkSituationalAwareness.vue?vue&type=script&lang=js"
export * from "./WorkSituationalAwareness.vue?vue&type=script&lang=js"
import style0 from "./WorkSituationalAwareness.vue?vue&type=style&index=0&id=ad3d7fb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad3d7fb0",
  null
  
)

export default component.exports